export default {
  pageTitle: 'تحديثات الشركة',
  viewAll: 'عرض الكل',
  showDescription: 'عرض الوصف',
  hideDescription: 'إخفاء الوصف',
  expandNamed: 'عرض الوصف لتحديث {{title}}',
  collapseNamed: 'إخفاء الوصف لتحديث {{title}}',
  title: 'العنوان',
  description: 'الوصف',
  date: 'التاريخ',
  datePlaceholder: 'YYYY-MM-DD',
  actions: 'الإجراءات',
  search: 'البحث في تحديثات الشركة',
  create: 'تحديث جديد',
  edit: 'تعديل التحديث',
  view: 'تفاصيل تحديث الشركة',
  delete: 'حذف التحديث',
  editNamed: 'تعديل {{title}}',
  deleteNamed: 'حذف {{title}}',
  deleteConfirmation: 'هل تريد حذف "{{title}}"؟',
  cancel: 'إلغاء',
  close: 'إغلاق',
  save: 'حفظ',
  retry: 'إعادة المحاولة',
  loading: 'جار تحميل تحديثات الشركة...',
  empty: 'لا توجد تحديثات للشركة بعد',
  noResults: 'لا توجد تحديثات تطابق البحث',
  selectCompany: 'اختر شركة لعرض تحديثاتها',
  created: 'تم إنشاء تحديث الشركة',
  updated: 'تم تعديل تحديث الشركة',
  deleted: 'تم حذف تحديث الشركة',
  validation: {
    titleRequired: 'أدخل عنوانا',
    titleLength: 'يجب ألا يتجاوز العنوان 255 حرفا',
    descriptionRequired: 'أدخل وصفا',
    descriptionLength: 'يجب ألا يتجاوز الوصف 10000 حرف',
    dateRequired: 'اختر التاريخ',
    dateInvalid: 'أدخل تاريخا صالحا بصيغة YYYY-MM-DD',
  },
  errors: {
    400: 'بعض الحقول أو معلمات البحث غير صالحة. تحقق منها وأعد المحاولة.',
    401: 'يرجى تسجيل الدخول مجددا للوصول إلى تحديثات الشركة.',
    403: 'ليس لديك صلاحية لتنفيذ هذا الإجراء لهذه الشركة.',
    404: 'هذا التحديث غير موجود أو تم حذفه أو غير متاح في الشركة المحددة.',
    general: 'تعذر إكمال الطلب. تحقق من اتصالك وأعد المحاولة.',
  },
};
